import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface RestaurantState {
  timeZone: string | null
}

const initialState: RestaurantState = {
  timeZone: null
}

const restaurantSlice = createSlice({
  name: 'restaurant',
  initialState,
  reducers: {
    setRestaurantTimeZone(state, action: PayloadAction<string | null>) {
      state.timeZone = action.payload
    }
  }
})

export const { setRestaurantTimeZone } = restaurantSlice.actions
export default restaurantSlice.reducer
